import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";
import { GetStreakDaysInput } from "./types";

export const getProfile: ApiMethod<
  void,
  Api.Server.GetProfileStatsOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ReaderStatistics_Client(
          undefined,
          Api.apiClient
        );

        return client.readerStatistics_profile_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getUser: ApiMethod<
  void,
  Api.Server.ReaderStatisticsOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ReaderStatistics_Client(
          undefined,
          Api.apiClient
        );

        return client.readerStatistics_user_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getTopConsumedCategories: ApiMethod<
  void,
  Api.Server.GetUserTopConsumedCategoriesOutput[],
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_ReaderStatistics_Client(
          undefined,
          Api.apiClient
        );

        return client.readerStatistics_topConsumedCategories_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getProfileStreakStats: ApiMethod<
  void,
  Api.Server.GetProfileStreakStatsOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_UserContentUsageHistory_Client(
          undefined,
          Api.apiClient
        );

        return client.userContentUsageHistory_profileStreakStats_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getStreakDays: ApiMethod<
  GetStreakDaysInput,
  Api.Server.GetConsumptionConsecutiveDaysOutput[],
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_UserContentUsageHistory_Client(
          undefined,
          Api.apiClient
        );

        return client.userContentUsageHistory_consecutiveConsumptionDays_get_V1(
          body.fromDate,
          body.toDate
        );
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};
